export default function({ state, commit, dispatch }, { patient, provider, event}) {
    // If all events have been loaded, further queries are not necessary

    return dispatch('get', {
        url: '/provider/' + provider + '/patient/' + patient + '/event/' + event,
    }, {
        root: true
    })
    .then((eventResponse) => {
        commit('updatePatient', {
            id: patient,
            event: [eventResponse]
        })
    })
    .catch((error) => {
        throw error
    })
}
